import { fail, type Result, succeed } from '@/domain/shared/Result';

export type EmailError = 'required' | 'email-invalid';

/** Objet-valeur : une adresse e-mail normalisée et toujours valide. */
export class Email {
  private static readonly PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  readonly value: string;

  private constructor(value: string) {
    this.value = value;
  }

  static parse(raw: string): Result<Email, EmailError> {
    const normalized = raw.trim().toLowerCase();
    if (normalized === '') return fail('required');
    if (!Email.PATTERN.test(normalized)) return fail('email-invalid');
    return succeed(new Email(normalized));
  }

  equals(other: Email): boolean {
    return this.value === other.value;
  }

  toString(): string {
    return this.value;
  }
}
